export class NotificationRequest {
  size?: number = 10;
  page?: number;
  isRead?: boolean;

  getUrl(): string {
    var result = '';
    result += `?size=${this.size}`;
    if (this.page) {
      result += `&page=${this.page}`;
    }
    if (this.isRead != null) {
      result += `&isRead=${this.isRead}`;
    }

    return result;
  }
}